// extracted by mini-css-extract-plugin
export default {"socialActivityHead":"SocialActivity_socialActivityHead__bxZRO","wrapper":"SocialActivity_wrapper__eI+Ru"};